import { create } from 'zustand';
import type { SubscriptionState as ApiState } from '../services/subscriptionService';

interface SubscriptionStoreState {
  data: ApiState | null;
  setData: (data: ApiState | null) => void;
  reset: () => void;
}

export const useSubscriptionStore = create<SubscriptionStoreState>((set) => ({
  data: null,
  setData: (data) => set({ data }),
  reset: () => set({ data: null }),
}));
